import {syncDashboards} from "src/util/OldDashboardLink.js"
const state = () => ({
  pinnedUser: null
  /* 
  pinnedUser = {
      id,
      login,
      first_name,
      last_name
  }
  */
})

// getters
const getters = {
  getPinnedUsersName: (state, getters) => {
    return state.pinnedUser.first_name + " " + state.pinnedUser.last_name
  },
  getPinnedUsersFirstName(state, getters) {
    return state.pinnedUser.first_name
  },
  getPinnedUsersLastName(state, getters) {
    return state.pinnedUser.last_name
  },
  getPinnedUsersLogin(state, getters) {
    return state.pinnedUser?.login
  },
  getPinnedUsersPractice(state, getters) {
    return state.pinnedUser?.practice
  },
  getPinnedUsersId(state, getters) {
    return state.pinnedUser?.id
  },
  getPinnedUsersWeightSystem(state,getters){
    return state.pinnedUser?.weight_system
  },
  getPinnedUsersDob(state,getters){
    return state.pinnedUser?.ppI_DOB
  },
  isUserPinned(state, getters) {
    if(state.pinnedUser){
      return true
    }
    return false
  }
}

// actions
const actions = {
}

// mutations
const mutations = {
  pinUser(state, user) {
    state.pinnedUser = user
    // also pin user on old manage area
    syncDashboards(null)

  },
  clearUser(state) {
    state.pinnedUser = null
    syncDashboards(null)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}